import React from 'react';
import { TextInput, useFormContextRequired } from 'ui-builder';
import { EventTask, useAuthenticationContext } from 'nekst-api';

export default function OrganizerInput() {
  const formContext = useFormContextRequired<EventTask>();

  const authenticationContext = useAuthenticationContext();

  const organizerProfile = formContext.data?._organizerProfile || authenticationContext!.user.profile;

  return (
    <TextInput
      source="organizer"
      value={organizerProfile.name.fullName}
      label="Organizer"
      isDisabled
    />
  );
}
